import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import { SECTION_KEYS } from '../../constants/sections';
import { useCheckout } from '../../hooks/useCheckout';
import CheckoutCard from '../CheckoutCard';
import EditView from './EditView';
import SummaryView from './SummaryView';

function PrincipalAddressCard({ hideEdit, sectionNumber }) {
  const { formState } = useFormContext();
  const { validSections } = useCheckout();

  const sectionKey = SECTION_KEYS.PRINCIPAL_ADDRESS;
  const isValid = validSections[sectionKey];

  const showSubtitle = !isValid && !formState.isSubmitted;

  // TODO: translate strings
  const title = 'Business address';
  const subtitle = showSubtitle ? "We couldn't find your business address." : null;

  return (
    <CheckoutCard
      hideEdit={hideEdit}
      sectionKey={sectionKey}
      sectionNumber={sectionNumber}
      subtitle={subtitle}
      title={title}
    >
      <CheckoutCard.Summary>
        <SummaryView sectionKey={sectionKey} />
      </CheckoutCard.Summary>
      <CheckoutCard.Edit>
        <EditView sectionKey={sectionKey} />
      </CheckoutCard.Edit>
    </CheckoutCard>
  );
}

PrincipalAddressCard.propTypes = {
  hideEdit: PropTypes.bool,
  sectionNumber: PropTypes.number.isRequired
};

export default PrincipalAddressCard;
